const aiHub = {
  modeChat: "צ'אט",
  modeChatDesc: "שיחה כללית עם העוזר",
  modeAnalyze: "ניתוח",
  modeAnalyzeDesc: "ניתוח נתוני פרויקטים וציוני בריאות",
  modeWrite: "כתיבה",
  modeWriteDesc: "טיוטת מסמכים, מיילים ודוחות",
  modeDecompose: "פירוק",
  modeDecomposeDesc: "פירוק אפיקים לסיפורים ומשימות",
  modeWork: "מנהל עבודה",
  modeWorkDesc: "מנהל העבודה של GAM — יודע מה קיים, מה פתוח, ומה לעשות הבא",
  workConnected: "מחובר",
  workDisconnected: "לא מחובר",
  workSuggestStatus: "מה הסטטוס של הפרויקטים?",
  workSuggestNext: "מה המשימה הבאה?",
  workSuggestDecisions: "מה ההחלטות האחרונות?",
  workSuggestPriority: "מה הפריורטי הכי גבוה עכשיו?",
  confidenceHigh: "בטוח",
  confidenceMedium: "סביר",
  confidenceLow: "לא בטוח",
  actionConfirm: "אשר",
  actionCancel: "בטל",
  actionPreviewTitle: "אישור פעולה",
  newChat: "שיחה חדשה",
  conversations: "שיחות",
  noConversations: "אין שיחות עדיין",
  emptyChat: "בחר מצב והתחל שיחה",
  context: "הקשר",
  addContext: "הוסף הקשר",
  sendMessage: "שלח",
  typePlaceholder: "הקלד הודעה...",
  charCount: "תווים",
  suggestChatStatus: "מה הסטטוס היום?",
  suggestChatSummarize: "סכם את הפרויקטים הפעילים",
  suggestAnalyzeHealth: "נתח ציוני בריאות",
  suggestAnalyzeAttention: "מה דורש תשומת לב?",
  suggestWriteReport: "כתוב דוח שבועי",
  suggestWriteEmail: "נסח מייל ללקוח",
  suggestDecomposeEpic: "פרק אפיק לסיפורים",
  suggestDecomposeTasks: "צור משימות מפיצ'ר",
  thinking: "חושב...",
  mockDisclaimer: "מצב הדגמה — תגובות לדוגמה",
  deleteConversation: "מחק שיחה",
  untitled: "שיחה ללא שם",
  streaming: "מגיב...",
  stopGeneration: "עצור",
  tokenUsage: "שימוש יומי בטוקנים",
  tokenBudgetWarning: "80% מהתקציב היומי נוצל",
  tokenBudgetExceeded: "התקציב היומי נוצל — נסה שוב מחר",
  liveMode: "מצב חי",
  modelLabel: "מודל",
  conversationLimit: "הגעת למגבלת 50 הודעות — פתח שיחה חדשה",
  savingToCloud: "שומר...",
  savedToCloud: "נשמר בענן",
  offlineMode: "מצב לא מקוון",
  toolbarBold: "מודגש",
  toolbarItalic: "נטוי",
  toolbarStrikethrough: "קו חוצה",
  toolbarCode: "קוד",
  toolbarLink: "קישור",
  toolbarBulletList: "רשימה",
  toolbarNumberedList: "רשימה ממוספרת",
  toolbarConvertLang: "המר שפה",
  toolbarConvertTooltip: "תקן מקלדת עברית/אנגלית",
  agentOrchestrator: "מתאם",
  agentPm: "מנהל פרויקט",
  agentDev: "מפתח",
  agentDesign: "מעצב",
  agentQa: "בודק",
  agentStrategy: "אסטרטג",
  // AI Hub Pro — new keys
  knowledgeBase: "בסיס ידע",
  knowledgeDescription: "הוסף כתובות URL כידע למצב הנוכחי — ה-AI ישתמש בתוכן שלהם בשיחות",
  addUrl: "הוסף",
  invalidUrl: "כתובת URL לא תקינה",
  urlLimit: "מקסימום 5 כתובות למצב",
  urlDuplicate: "כתובת כבר קיימת",
  urlFetchFailed: "לא ניתן לגשת לכתובת",
  searchConversations: "חיפוש שיחות...",
  docPanel: "מסמך",
  searchDocument: "חיפוש מסמך...",
  noDocSelected: "בחר מסמך לצפייה",
  attachImage: "צרף תמונה",
  dropImageHere: "שחרר תמונה כאן",
  replyTo: "הגב",
  cancelReply: "ביטול הגבה",
  mentionEntity: "חיפוש ישות...",
  recentEntities: "אחרונים",
  noEntitiesFound: "לא נמצאו ישויות",
  copyMessage: "העתק",
  regenerate: "צור מחדש",
  // Action Preview
  actionExecuting: "...מבצע",
  actionSuccess: "בוצע",
  actionError: "נכשל",
  actionRetry: "נסה שוב",
  actionNotionTask: "משימת Notion",
  // Personas
  personaSelector: "יועץ",
  noPersona: "ללא יועץ",
  selectPersona: "בחר יועץ",
  clearPersona: "נקה",
  domainOperations: "תפעול",
  domainFinance: "כספים",
  domainLegal: "משפטי",
  domainHr: "משאבי אנוש",
  domainMarketing: "שיווק",
  domainTech: "טכנולוגיה",
  domainStrategy: "אסטרטגיה",
  domainGeneral: "כללי",
} as const;
export default aiHub;
